import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {
  Button,
  DrawerBody,
  DrawerFooter,
  Typography,
  Alert,
  Link
} from '@one-thd/sui-atomic-components';
import { useCustomerInformation } from '../hooks/useCustomerInformation';
import { ProductExceptions } from '../product-exceptions/ProductExceptions';
import {
  saveProjectIdOnSession, triggerCloseQuoteAnalytics
} from '../../utils/helpers';
import { CREATE_A_QUOTE_CLOSE_BUTTON, ADD_TO_QUOTE_CLOSE_BUTTON } from '../shared/Constants';

const SuccessDrawer = ({
  onClose,
  plural = false,
  quoteId,
  quoteName,
  userId,
  projectId = '',
  quoteOriginAnalytic,
  productExceptions = []
}) => {
  const { svocId } = useCustomerInformation();
  const updateAlertClass = classNames(
    'sui-min-w-0',
    'sui-flex',
    'sui-flex-col',
    'sui-overflow-auto',
    'sui-leading-[1.286]',
    'sui-mr-2',
    'sui-pt-[2px]',
    'sui-pb-2'
  );

  const handleClose = () => {
    if (quoteOriginAnalytic === 'add-to-quote') {
      triggerCloseQuoteAnalytics(ADD_TO_QUOTE_CLOSE_BUTTON);
    }
    if (quoteOriginAnalytic === 'create-a-quote') {
      triggerCloseQuoteAnalytics(CREATE_A_QUOTE_CLOSE_BUTTON);
    }
    onClose();
  };

  const handleLinkClick = () => {
    window.LIFE_CYCLE_EVENT_BUS.trigger('add-to-quote.quoteNameLink');
    saveProjectIdOnSession(projectId);
  };

  return (
    <>
      <DrawerBody>
        <Alert status="success" data-testid="success-alert">
          <div className={updateAlertClass}>
            <Typography data-testid="quote-creation-success-message">
              Success! Your {plural ? 'items have' : 'item has'} been added to your quote,{' '}
            </Typography>
            <Typography data-testid="quote-name-link" truncate>
              <Link
                onClick={handleLinkClick}
                href={`/quote/details/${quoteId}/customer/${svocId}/user/${userId}`}
              >
                {quoteName}
              </Link>
            </Typography>
          </div>
        </Alert>
        {productExceptions.length > 0 && (
          <ProductExceptions productExceptions={productExceptions} />
        )}
      </DrawerBody>
      <DrawerFooter>
        <Button fullWidth variant="primary" onClick={handleClose}>
          OK
        </Button>
      </DrawerFooter>
    </>
  );
};

SuccessDrawer.propTypes = {
  onClose: PropTypes.func.isRequired,
  plural: PropTypes.bool,
  quoteName: PropTypes.string.isRequired,
  quoteId: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  projectId: PropTypes.string,
  quoteOriginAnalytic: PropTypes.string.isRequired,
  productExceptions: PropTypes.arrayOf(
    PropTypes.shape({
      flag: PropTypes.string.isRequired,
      fulfillment: PropTypes.shape({}),
      identifiers: PropTypes.shape({}),
      pricing: PropTypes.shape({}),
      itemId: PropTypes.string,
      id: PropTypes.string,
      quantity: PropTypes.number
    })
  )
};

SuccessDrawer.displayName = 'SuccessDrawer';

export { SuccessDrawer };
